'use client'

import React from 'react'
import Header from '../../components/ui/Header'
import { useUser } from "@clerk/nextjs"

export default function TermsPage() {
  useUser()

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="bg-white px-6 py-32 lg:px-8">
        <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Terms of Service</h1>
          
          <div className="mt-10">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900">1. Service Description</h2>
            <p className="mt-6">
              Analyzer.CV provides AI-powered analysis of CVs and job descriptions to help recruiters make better hiring decisions.
              Our service is provided on an "as is" and "as available" basis.
            </p>
          </div>

          <div className="mt-10">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900">2. Data Processing and Storage</h2>
            <p className="mt-6">
              <strong>Important:</strong> We do not store any CVs or job descriptions uploaded to our platform. All documents
              are processed in real-time and immediately discarded after analysis. This approach ensures:
            </p>
            <ul className="mt-4 list-disc list-inside space-y-2">
              <li>Maximum privacy for candidates</li>
              <li>Protection of company confidential information</li>
              <li>Compliance with data protection regulations</li>
              <li>Minimal data footprint</li>
            </ul>
          </div>

          <div className="mt-10">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900">3. User Responsibilities</h2>
            <p className="mt-6">
              Users are responsible for:
            </p>
            <ul className="mt-4 list-disc list-inside space-y-2">
              <li>Ensuring they have the right to process any CV or job description they upload</li>
              <li>Maintaining the confidentiality of their account credentials</li>
              <li>All activity that occurs under their account</li>
              <li>Compliance with applicable laws and regulations</li>
            </ul>
          </div>

          <div className="mt-10">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900">4. Subscription and Payments</h2>
            <p className="mt-6">
              Our service is provided on a subscription basis. Users can choose from different plans with varying
              features and usage limits. All subscriptions are billed in advance and are non-refundable.
            </p>
          </div>

          <div className="mt-10">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900">5. Privacy and Security</h2>
            <p className="mt-6">
              We take privacy and security seriously. While we don't store CVs or job descriptions, we do implement
              strict security measures for all data processing:
            </p>
            <ul className="mt-4 list-disc list-inside space-y-2">
              <li>Encrypted data transmission</li>
              <li>Secure, ephemeral processing</li>
              <li>Regular security audits</li>
              <li>Access controls and authentication</li>
            </ul>
          </div>

          <div className="mt-10">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900">6. Contact</h2>
            <p className="mt-6">
              For any questions about these terms, please contact us at{' '}
              <a href="mailto:contact@analyzer.cv" className="text-blue-600 hover:text-blue-800">
                contact@analyzer.cv
              </a>
            </p>
          </div>

          <div className="mt-10">
            <p className="text-sm text-gray-500">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}